import { render, staticRenderFns } from "./AsignacionSitrack.vue?vue&type=template&id=08752d88&scoped=true&"
import script from "./AsignacionSitrack.vue?vue&type=script&lang=ts&"
export * from "./AsignacionSitrack.vue?vue&type=script&lang=ts&"
import style0 from "./AsignacionSitrack.vue?vue&type=style&index=0&id=08752d88&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08752d88",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('08752d88', component.options)
    } else {
      api.reload('08752d88', component.options)
    }
    module.hot.accept("./AsignacionSitrack.vue?vue&type=template&id=08752d88&scoped=true&", function () {
      api.rerender('08752d88', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Asignacion_sitrack/AsignacionSitrack.vue"
export default component.exports